<div class="container-fluid m-0 p-0">
  <div class="blog-header-container">
    <h1 translate>ბლოგი</h1>
  </div>
</div>
<ng-container *ngIf="i18nService.language !== 'EN'">
  <div class="container blog-item custom">
    <h1>აქ. ახლა თიბისი ლიზინგი ინფრასტრუქტურის სექტორის მხარდასაჭერად</h1>
    <h6>მაისი 2022</h6>
    <br />
    <p>
      თიბისი ლიზინგის პორტფელის მესამედი ინფრასტრუქტურის სეგმენტზე მოდის. გასაკვირი არც არის, დაფინანსების მარტივი და
      ეფექტური მეთოდი ხომ განსაკუთრებით მნიშვნელოვანია მაშინ, როცა ძვირადღირებულ აქტივებზე ვსაუბრობთ?
    </p>

    <p>
      სამშენებლო-დეველოპერული საქმიანობა თუ მსხვილი ინფრასტრუქტურული პროექტების განხორციელება მრავალი გამოწვევითაა სავსე
      რომლის დროსაც თანამედროვე მანქანა-დანადგარებს გადამწყვეტი მნიშვნელობა ენიჭებათ. სწორად შერჩეული და გამოყენებული
      აქტივი ამცირებს სამუშაო დროს და ხარჯს, შესაბამისად ზრდის საქმმიანობის ეფექტს (ანუ მოგებას), ხარისხსს და მეტწილად
      განაპირობებს დასაქმებულთა კმაყოფილებასაც.
    </p>

    <img src="../../../../assets/blog/for-infrastructure/img1.jpg" alt="" />

    <p>
      როგორც თიბისი ლიზინგის ინფრასტრუქტურის სეგმენტის ექსპერტები გვირჩევენ, მძიმე ტექნიკის შერჩევამდე რამდენიმე კარგად
      ნაცნობი ფაქტორი უნდა გავითვალისწინოთ:
    </p>

    <p>
      <i class="subhead capital light-blue"><b>1. მომწოდებელი</b></i>
    </p>

    <p>
      როგორც ნებისმიერი სხვა აქტივის შერჩევისას სანდრო, მაღალი რეპუტაციის მქონე მომწოდებლებთან მუშაობა აუცილებლობას
      წარმოადგენს. მათთან კომუნიკაცია გამჭირვალე და კომფორტულია, შემოთავაზებული ტექნიკის ხარისხი და მოწოდების დრო,
      სრულად შეესაბამება მოლოდინებს, ასევე ჯეროვნად სრულდება საგარანტიო პირობები და არ ფერხდებით ბიზნესის წარმოების
      პროცესში.
    </p>

    <p>
      <i class="subhead capital light-blue"><b>2. ხარისხი</b></i>
    </p>

    <p>
      ბუტაფორულად რომ არ ჟღერდეს გეტყვით, რომ მძიმე ტექნიკის შემთხვევაში ხარისხი შეკეთებისა და მოვლა-პატრონობასთან
      დაკავშირებული ხარჯების შემცირების პროპორციული ცნებაა, შესაბამისად, გაიზრდება თქვენი მოგება.
    </p>

    <p>
      <i class="subhead capital light-blue"><b>3. დაფინანსება</b></i>
    </p>

    <p>
      რა თქმა უნდა, გვერდს ვერც ამ მნიშვნელოვან საკითხს ავუვლით. განსაკუთრებით საფრთხილო, საყურადღებო, ძვირადღირებული
      აქტივის შეძენისთვის მსოფლიოში აპრობირებული მეთოდი - ლიზინგია.
    </p>

    <p>
      დაფინანსების ეს მექანიზმი გაძლევთ საშუალებას ისარგებლოთ აქტივით ყოველთვიური ანგარიშსწორების სანაცვლოდ, თან თქვენზე
      მორგებული პირობებით.
    </p>
  </div>

  <div class="container-fluid m-0 p-0">
    <div class="full-color background-light-blue">
      <div class="container">
        <div class="row image-quote-wrapper">
          <div class="col-12 col-md-5 mb-4 mb-md-0 quote-image">
            <img src="../../../../assets/blog/for-infrastructure/img2.jpg" alt="" />
          </div>
          <div class="col-12 col-md-7 quote-text-wrapper">
            <p class="image-quote">
              „გარდა იმისა, რომ ლიზინგის დამტკიცების პროცესი არის მარტივი და დროში ეფექტური, მომხარებლის ინტერესებს სხვა
              ასპექტებშიც გადამწყვეტ მნიშვნელობას ვანიჭებთ. სურვილის შემთხვევაში, ჩვენ თავად ვუკავშირდებით ადგილობრივ თუ
              საზღვარგარეთ არსებულ მომწოდებელს, ვეხმარებით ბიზნესს სასურველი აქტივის შერჩევაში, უზრუნველვყოფთ მის
              დაფინანსებას, მიწოდებას და შემდგოში მოვლა-პატრონობასთან დაკავშირებულ პროცესებს.”
            </p>
            <p class="quote-author">ნოდარ ბარბაქაძე</p>
            <p class="quote-author-title">საკრედიტო დეპარტამენტის უფროსი</p>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="container blog-item custom">
    <p class="solid-header" style="color: #1a1a1a; font-size: 28px">მთავარი უპირატესობა</p>

    <p>
      <i class="subhead capital light-blue"><b>ექსკლუზიური პარტნიორობა ოფიციალურ წარმომადგენლებთან</b></i>
    </p>

    <p>
      თიბისი ლიზინგი რიგი წამყვანი ვენდორების ექსკლუზიური პარტნიორია, რაც შემოთავაზებულ პირობებში მოქნილობას
      განაპირობებს.
    </p>

    <p>
      <i class="subhead capital light-blue"><b>სპეციალური შეთავაზებები </b></i>
    </p>

    <p>
      სხვადასხვა პერიოდში სპეციალური შეთავაზებები მუშავდება პარტნიორ მომწოდებლებთან, რაც 0%-იანი თანამონაწილეობის,
      შემცირებული საპროცენტო განაკვეთისა თუ საშეღავათო პირობების სახით არის ფორმულირებული.
    </p>

    <p>
      <i class="subhead capital light-blue"><b>ერთი ინვოისის პრინციპი</b></i>
    </p>

    <p>
      შერჩეული ტიპის ლიზინგის მიხედვით აქტივის ფლობასთან დაკავშირებული ყველა ხარჯი გაერთიანებულია ერთ ინვოისში.
    </p>

    <p>
      <i class="subhead capital light-blue"><b>ქონების ნაკლები გადასახადი</b></i>
    </p>

    <p>
      რადგან ლიზინგისას აქტივი შენი კომპანიის სახელზე არ ირიცხება, არც ბუღალტრულ ბალანსზე იქონიებს გავლენას,
      შესაბამისად, ნაკლებია ქონების გადასახადი. ლიზინგის შემთხვევაში ქონების გადასახადი 1%-ის ნაცვლად, 0.6%-ით
      განისაზღვრება.
    </p>

    <img src="../../../../assets/blog/for-infrastructure/img3.jpg" alt="" />
  </div>

  <div class="container-fluid m-0 p-0">
    <div class="full-color background-light-blue">
      <div class="container">
        <p class="quote">
          “რეალურად, თუ აქტივის ტრანსპორტირება უცხოეთიდან ხდება, ჩვენ საკუთარ თავზე ვიღებთ მოწოდებისა თუ აქტივის
          შესაბამისობის რისკებს, შესაბამისად, თავისუფლად შეიძლება ითქვას, რომ ჩვენ გვაქვს საშუალება შევთავაზოთ ბიზნესს
          მომსახურების სრული ციკლი“
        </p>
      </div>
    </div>
  </div>

  <div class="container blog-item custom">
    <p>
      თუ კიდევ ფიქრობ, ღირს თუ არა ისარგებლო ლიზინგით მძიმე ტექნიკის შესაძენად, მოგვმართე აქ. ახლა და სპეციალისტებისგან
      მიიღე ამოწურავი კონსულტაცია შენთვის საინტერესო მიმართულებით.
    </p>

    <p style="color: #999999">ავტორი: ლალიკო თუმანიშვილი</p>
  </div>
</ng-container>

<ng-container *ngIf="i18nService.language === 'EN'">
  <div class="container blog-item custom">
    <h1>Here. Now TBC Leasing supports the infrastructure sector</h1>
    <h6>May 2022</h6>
    <br />
    <p>
      A third of TBC Leasing’s portfolio is in the infrastructure segment. It is not surprising, as financing is a
      simple and effective method, especially when we are talking about expensive assets.
    </p>

    <p>
      Construction and development activities, or the implementation of large infrastructure projects, are full of many
      challenges, during which modern machinery and equipment play a crucial role. Properly selected and utilized assets
      reduce working time and costs, thus increasing efficiency (i.e., profit), quality, and largely contribute to
      employee satisfaction as well.
    </p>

    <img src="../../../../assets/blog/for-infrastructure/img1.jpg" alt="" />

    <p>
      As experts in TBC Leasing’s infrastructure segment advise, there are several well-known factors to consider before
      selecting heavy machinery:
    </p>

    <p>
      <i class="subhead capital light-blue"><b>1. Supplier</b></i>
    </p>

    <p>
      As with selecting any other asset, working with reputable suppliers is essential. Communication with them is
      transparent and comfortable, the quality and delivery time of the offered equipment fully meet expectations, and
      warranty conditions are properly fulfilled, ensuring there are no delays in the business process.
    </p>

    <p>
      <i class="subhead capital light-blue"><b>2. Quality</b></i>
    </p>

    <p>
      To avoid sounding superficial, I’ll tell you that in the case of heavy machinery, quality is a proportional
      concept related to repair and maintenance costs, so your profit will increase accordingly.
    </p>

    <p>
      <i class="subhead capital light-blue"><b>3. Financing</b></i>
    </p>

    <p>
      Of course, we cannot overlook this important matter. The globally proven method for acquiring expensive, risky,
      and noteworthy assets is leasing.
    </p>

    <p>
      This financing mechanism allows you to use the asset in exchange for monthly payments, with terms tailored to your
      needs.
    </p>
  </div>

  <div class="container-fluid m-0 p-0">
    <div class="full-color background-light-blue">
      <div class="container">
        <div class="row image-quote-wrapper">
          <div class="col-12 col-md-5 mb-4 mb-md-0 quote-image">
            <img src="../../../../assets/blog/for-infrastructure/img2.jpg" alt="" />
          </div>
          <div class="col-12 col-md-7 quote-text-wrapper">
            <p class="image-quote">
              „Aside from the fact that the leasing approval process is simple and time-efficient, we also give crucial
              importance to the client's interests in other aspects. If desired, we directly contact local or foreign
              suppliers, assist the business in selecting the desired asset, ensure its financing, delivery, and the
              processes related to maintenance afterward.”
            </p>
            <p class="quote-author">Nodar Barbakadze</p>
            <p class="quote-author-title">Head of the Credit Department</p>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="container blog-item custom">
    <p class="solid-header" style="color: #1a1a1a; font-size: 28px">Main Advantages</p>

    <p>
      <i class="subhead capital light-blue"><b>Exclusive Partnership with Official Representatives</b></i>
    </p>

    <p>
      TBC Leasing is the exclusive partner of several leading vendors, which provides flexibility in the offered terms.
    </p>

    <p>
      <i class="subhead capital light-blue"><b>Special Offers</b></i>
    </p>

    <p>
      During various periods, special offers are developed with partner suppliers, which are formulated in the form of
      0% participation, reduced interest rates, or favorable terms.
    </p>

    <p>
      <i class="subhead capital light-blue"><b>One Invoice Principle</b></i>
    </p>

    <p>
      According to the selected type of leasing, all costs related to asset ownership are consolidated into one invoice.
    </p>

    <p>
      <i class="subhead capital light-blue"><b>Lower Property Tax</b></i>
    </p>

    <p>
      Since the asset is not registered in your company's name during leasing, it will not impact the accounting
      balance, resulting in a lower property tax. In the case of leasing, property tax is determined at 0.6% instead of
      1%.
    </p>

    <img src="../../../../assets/blog/for-infrastructure/img3.jpg" alt="" />
  </div>

  <div class="container-fluid m-0 p-0">
    <div class="full-color background-light-blue">
      <div class="container">
        <p class="quote">
          “In reality, if the asset is being transported from abroad, we take on the risks of delivery and asset
          compliance, so it can confidently be said that we have the ability to offer businesses a complete service
          cycle.“
        </p>
      </div>
    </div>
  </div>

  <div class="container blog-item custom">
    <p>
      If you're still wondering whether it's worth using leasing to purchase heavy machinery, contact us here. Now, and
      get comprehensive consultation from specialists on the area of interest to you.
    </p>

    <p style="color: #999999">Author: Laliiko Tumanishvili</p>
  </div>
</ng-container>
